import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * 资源/请求 相关数据格式化
 */

// import { LogInfo } from "@/lego-perf/utils";

var fix = function fix(t) {
  return Math.min(1e5, Math.max(parseInt(t.toString(), 10) || 0, 0));
};
var isJsonp = function isJsonp(name) {
  return /app\.zhuanzhuan\.com\//.test(name) && /callback\=/.test(name);
};
var formatEntryName = function formatEntryName(name) {
  try {
    var _URL = new URL(name),
      hostname = _URL.hostname,
      path = _URL.path;
    return "".concat(hostname).concat(path);
  } catch (error) {
    // console.log(error)
  }
  return name;
};

// TODO: 优化 name 去除 query hash
var getResult = function getResult() {
  var entry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var res = {
    start: fix((entry === null || entry === void 0 ? void 0 : entry.fetchStart) || 0),
    fstart: fix((entry === null || entry === void 0 ? void 0 : entry.requestStart) || (entry === null || entry === void 0 ? void 0 : entry.fetchStart) || 0),
    end: fix((entry === null || entry === void 0 ? void 0 : entry.responseEnd) || 0),
    name: formatEntryName(entry === null || entry === void 0 ? void 0 : entry.name)
  };
  return res;
};
var loadData = function loadData(params) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _opts$needAjax = opts.needAjax,
    needAjax = _opts$needAjax === void 0 ? true : _opts$needAjax,
    _opts$needImg = opts.needImg,
    needImg = _opts$needImg === void 0 ? true : _opts$needImg,
    _opts$needSource = opts.needSource,
    needSource = _opts$needSource === void 0 ? true : _opts$needSource;
  var result = {
    ajax: [],
    ajaxMax: [],
    ajaxMin: [],
    source: [],
    sourceMax: [],
    sourceMin: [],
    imgs: [],
    imgsMax: [],
    imgsMin: [],
    domain: []
  };
  var entries = performance.getEntries();
  var endTime = params.backup.fmp !== 0 ? params.backup.fmp * 1.2 : params.backup.loadTime * 1.7;
  var _iterator = _createForOfIteratorHelper(entries),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var entry = _step.value;
      if (entry.startTime > endTime) continue;
      if (entry.entryType == 'paint' && entry.name == 'first-contentful-paint') {
        params.backup.firstPiantTime = parseInt(entry === null || entry === void 0 ? void 0 : entry.startTime.toString(), 10);
      }

      // initiatorType: 'navigation' | 'link' | 'script' | 'fetch' | 'xmlhttprequest' | 'img' | 'css' ;
      var item = getResult(entry);
      switch (entry === null || entry === void 0 ? void 0 : entry.initiatorType) {
        case 'link':
        case 'script':
          if (isJsonp(item.name)) {
            result.ajaxMax.push(item.end > 0 ? item.end : 0);
            result.ajaxMin.push(item.start > 0 ? item.start : 0);
            needAjax && result.ajax.push(item);
            continue;
          }
          result.sourceMax.push(item.end > 0 ? item.end : 0);
          result.sourceMin.push(item.start > 0 ? item.start : 0);
        case 'navigation':
          params.backup.bodysize = (entry === null || entry === void 0 ? void 0 : entry.decodedBodySize) || 0;
          needSource && result.source.push(item);
          continue;
        case 'fetch':
        case 'xmlhttprequest':
          result.ajaxMax.push(item.end > 0 ? item.end : 0);
          result.ajaxMin.push(item.start > 0 ? item.start : 0);
          needAjax && result.ajax.push(item);
          continue;
        case 'img':
        case 'css':
          if (/\.jpg|\.jpeg|\.png|\.svg|\.gif|\.webp/i.test(item.name)) {
            result.imgsMax.push(item.end > 0 ? item.end : 0);
            result.imgsMin.push(item.start > 0 ? item.start : 0);
            needImg && result.imgs.push(item);
          }
          continue;
        default:
          continue;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return result;
};
var formatVal = function formatVal() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var fmp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var res = [];
  try {
    if (list.length) {
      // 添加首屏接口/静态资源标志
      res = list.map(function (v) {
        if (v.start < fmp) {
          v.first = true;
        }
        return "".concat(v.name, "|").concat(v.start, "|").concat(v.fstart, "|").concat(v.end, "|").concat(v.first || false);
      });
    }
  } catch (err) {
    console.error(err);
  }
  return res;
};

//  'source' | 'ajax' | 'imgs'
var classifyData = function classifyData() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var result = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref = (params === null || params === void 0 ? void 0 : params.backup) || {},
    fmp = _ref.fmp,
    firstPiantTime = _ref.firstPiantTime;
  var time = fmp || firstPiantTime;
  var res = {
    ajax: [],
    ajaxMax: 0,
    ajaxMin: 0,
    ajaxTime: 0,
    //
    source: [],
    sourceMax: 0,
    sourceMin: 0,
    sourceTime: 0,
    //
    imgs: [],
    imgsMax: 0,
    imgsMin: 0,
    imgsTime: 0,
    domain: []
  };
  //
  res.ajax = formatVal(result.ajax, time) || []; // `${v.name}|${v.start}|${v.fstart}|${v.end}|${v.first || false}`
  res.ajaxMax = fix(Math.max.apply(Math, _toConsumableArray(result.ajaxMax)));
  res.ajaxMin = fix(Math.min.apply(Math, _toConsumableArray(result.ajaxMin)));
  res.ajaxTime = fix(res.ajaxMax - res.ajaxMin) || 0;
  //
  res.source = formatVal(result.source, time);
  res.sourceMax = fix(Math.max.apply(Math, _toConsumableArray(result.sourceMax)));
  res.sourceMin = fix(Math.min.apply(Math, _toConsumableArray(result.sourceMin)));
  res.sourceTime = fix(res.sourceMax - res.sourceMin);
  //
  res.imgs = formatVal(result.imgs, time) || [];
  res.imgsMax = fix(Math.max.apply(Math, _toConsumableArray(result.imgsMax)));
  res.imgsMin = fix(Math.min.apply(Math, _toConsumableArray(result.imgsMin)));
  res.imgsTime = fix(res.imgsMax - res.imgsMin);
  return res;
};
export var initResource = function initResource(params) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var performance = window.performance;
  if (!performance.getEntries) return params;
  var result = loadData(params, opts);
  // LogInfo('loadData', result)
  var res = classifyData(params, result);
  // LogInfo('classifyData', res)
  Object.assign(params.backup, _objectSpread({}, res));
  return params;
};